import { jsx as t, jsxs as P, Fragment as Ee } from "react/jsx-runtime";
import { useContext as _e, useState as K, forwardRef as ge, useRef as ae, useEffect as ee, useMemo as ye } from "react";
import { Controller as G, useForm as Fe } from "react-hook-form";
import { useTranslation as me } from "react-i18next";
import H from "classnames";
import "./components/Breadcrumbs/index.js";
import ke from "./components/Button/index.js";
import "reactjs-popup";
import Oe from "./icons/Checkmark.js";
import qe from "./icons/Trash.js";
import Re from "./icons/QuestionCircle.js";
import Ue from "./icons/Attention.js";
import { ThemeContext as he } from "./components/ThemeContext/index.js";
import He from "./components/Modal/index.js";
import Ne from "./fields/FieldContainer/index.js";
import We from "./fields/Checkbox/index.js";
import je from "./fields/ContentEditable/index.js";
import Pe from "./fields/DateInput/index.js";
import "date-fns";
import Je, { Option as be } from "rc-select";
import Le from "./helpers/nanoid.js";
import Ke from "./fields/Select/hooks/useDropdownWidth.js";
import Se from "./hooks/useDebounce.js";
import "react-dropzone";
import Xe from "./fields/Input/index.js";
import "react-dom";
import "./fields/InputTooltip/index.js";
import Ze from "./fields/PhoneInput/index.js";
import "./fields/SocialSelect/index.js";
import Te from "./fields/Switcher/index.js";
import Qe from "./fields/Textarea/index.js";
import Me from "sanitize-html";
import "i18next";
import "@dnd-kit/core";
import "@dnd-kit/sortable";
import "react-number-format";
import "immutability-helper";
import Ge from "./components/Tooltip/index.js";
import { menuItemSelectedIcon as Ye, suffixIcon as et, maxTagPlaceholder as tt, builtinPlacements as nt, optionRender as it, dropdownRender as ot, getSelectMode as rt } from "./fields/Select/elements/index.js";
import Y, { getInputSelection as st, setInputSelection as at } from "./fillDocument/FillingItem/valueMutationFunctions.js";
import lt from "./data/phoneMasks.js";
import ct from "./fillDocument/FillGroup/index.js";
import { groupCompany as dt, superFields as Z, getSuperFieldsProps as ve, getSuperFieldType as mt, parseOrgData as ut, parseBankData as ft, parsePassportData as pt } from "./fillDocument/FillFolder/fillHelpers.js";
const _t = ({
  loadingUrl: u,
  loadingMethod: r = "post",
  loadingParam: g = "query",
  loadingMapper: _
}) => {
  const { token: o, lang: O, apiUrl: L } = _e(he), [T, v] = K(), [$, f] = K(!1), x = Se((d) => {
    if (!u || d.trim().length <= 1)
      return;
    f(!0);
    const M = L + u + (r === "get" ? `?${g}=${d.trim()}` : "");
    fetch(M, {
      method: r,
      body: r === "post" ? JSON.stringify({ [g]: d.trim() }) : null,
      headers: { Authorization: `Bearer ${o}`, "X-Language": `${O}`, "Content-Type": "application/json" }
    }).then(async (q) => {
      const C = await q.json(), B = _ ? _(C, d) : C.map((A) => ({ label: A, value: A }));
      v(B), setTimeout(() => f(!1));
    }).catch((q) => f(!1));
  }, 200);
  return { loadedOptions: T, isLoading: $, loadOptions: x };
}, gt = "forma-ui__select__input", ht = "forma-ui__select__readonly", wt = "forma-ui__select__secondary", se = {
  input: gt,
  readonly: ht,
  secondary: wt
}, yt = ge(({
  id: u = Le(8),
  name: r,
  onChange: g,
  onFocus: _,
  onBlur: o,
  hidden: O,
  className: L,
  disabled: T,
  placeholder: v,
  readOnly: $,
  meta: f = {},
  viewStyle: x = "primary",
  multiple: d,
  options: M = [],
  defaultValue: q,
  value: C,
  ...B
}, A) => {
  const {
    showArrow: S = !0,
    creatable: N,
    loadingUrl: s,
    loadingMethod: i,
    loadingParam: z,
    loadingMapper: I,
    dropdownWidth: b,
    dropdownClassName: l,
    afterDropdownButton: a,
    notFoundMessage: R,
    showClearButton: n,
    customLabelKey: c,
    showTags: p
  } = f, h = rt({ creatable: N, multiple: d, readOnly: $, loadingUrl: s }), { t: m } = me(), E = A && "current" in A ? A : ae(null), W = ae(null), w = ae(null), { loadedOptions: y, isLoading: V, loadOptions: e } = _t({ loadingUrl: s, loadingMethod: i, loadingParam: z, loadingMapper: I }), { dropdownMatchSelectWidth: F } = Ke({ dropdownWidth: b, containerRef: W }), [te, oe] = K(null), [ue, U] = K(!1), [fe, ne] = K(!1);
  ee(() => {
    re(), document.dispatchEvent(new Event("selectUpdate", { bubbles: !0 }));
  }, [M, y]);
  const re = () => {
    setTimeout(() => {
      var k, X;
      if (w.current) {
        const J = (X = (k = w.current) == null ? void 0 : k.closest(".rc-select-dropdown")) == null ? void 0 : X.classList.value;
        ["topLeft", "topRight", "bottomLeft", "bottomRight"].forEach((ie) => {
          J != null && J.match(ie) && oe(ie);
        });
      }
    }, 100);
  }, le = (k, X) => {
    let J = Array.isArray(k) ? k.join(",") : k;
    g && g({ target: { name: r, value: J } }, X.data), s && e(J);
  }, Be = (k) => {
    _ && _(k), re(), U(!0), document.dispatchEvent(new Event("selectOpen", { bubbles: !0 }));
  }, Ve = (k) => {
    o && o(k), U(!1), ne(!1), document.dispatchEvent(new Event("selectClose", { bubbles: !0 }));
  };
  let pe = /* @__PURE__ */ t("span", { children: m("uikit:empty") });
  h === "combobox" && (!C || V ? pe = null : R && (pe = /* @__PURE__ */ t("div", { onMouseUp: () => ne(!1), children: R }))), v || (N ? v = m("uikit:enter_value") : v = m("uikit:select_value"));
  const De = !$ && (!!s || N), we = typeof F == "number", ze = p ? 5 : 1, Ae = (k) => k.closest(".fill-document-content") ?? k.closest(".modal__content") ?? document.body;
  return /* @__PURE__ */ t(
    Ne,
    {
      id: u,
      hidden: O,
      ...B,
      ...f,
      isShowTooltip: ue,
      ref: W,
      children: /* @__PURE__ */ t(
        Je,
        {
          id: u,
          open: fe,
          onDropdownVisibleChange: ne,
          onChange: le,
          onFocus: Be,
          onBlur: Ve,
          className: H(
            `rc-select_${u}`,
            se.input,
            se[x],
            L,
            f.icon && se.withIcon,
            f.error && "error",
            f.success && "success",
            we && "rc-select-wide",
            te && `rc-select-${te}`,
            N && "rc-select-creatable",
            p && "rc-select-tags",
            $ && se.readonly
          ),
          placeholder: v,
          mode: h,
          disabled: T,
          allowClear: n,
          optionLabelProp: c,
          menuItemSelectedIcon: ({ isSelected: k }) => Ye(k, d),
          suffixIcon: ({ loading: k }) => et(k, S, f.icon),
          loading: V,
          removeIcon: null,
          notFoundContent: pe,
          maxTagPlaceholder: tt,
          maxTagCount: ze,
          listHeight: 290,
          dropdownAlign: { offset: [0, 4] },
          dropdownMatchSelectWidth: F,
          builtinPlacements: nt,
          dropdownClassName: H(
            l,
            se[x],
            d && "rc-select-dropdown-multiple",
            we && "rc-select-dropdown-wide"
          ),
          showSearch: De,
          optionRender: (k) => it(k, M, y, C),
          dropdownRender: (k) => ot(k, w, a, () => ne(!1)),
          getPopupContainer: Ae,
          virtual: !1,
          defaultValue: q,
          value: d && C ? C.split(",") : C || void 0,
          ref: E,
          ...B,
          children: y ? (
            // data attribute returns object, but it need for backward compatibility options list params
            y.map(({ label: k, value: X, className: J, data: ce }, ie) => /* @__PURE__ */ t(be, { className: J, value: X, data: ce, children: k }, ie))
          ) : M.map(({ label: k, value: X, className: J, displayLabel: ce }, ie) => /* @__PURE__ */ t(be, { className: J, value: X, displayLabel: ce, children: k }, ie))
        }
      )
    }
  );
}), bt = "forma-ui__wysiwyg__container", vt = "forma-ui__wysiwyg__fieldContainer", xt = "forma-ui__wysiwyg__withIcon", Ct = "forma-ui__wysiwyg__input", It = "forma-ui__wysiwyg__readonly", $t = "forma-ui__wysiwyg__secondary", kt = "forma-ui__wysiwyg__label", Nt = "forma-ui__wysiwyg__total", Lt = "forma-ui__wysiwyg__button", St = "forma-ui__wysiwyg__toolbar", Tt = "forma-ui__wysiwyg__toolbarButton", Mt = "forma-ui__wysiwyg__active", Bt = "forma-ui__wysiwyg__toolbarButtonIcon", j = {
  container: bt,
  fieldContainer: vt,
  withIcon: xt,
  input: Ct,
  readonly: It,
  secondary: $t,
  label: kt,
  total: Nt,
  button: Lt,
  toolbar: St,
  toolbarButton: Tt,
  active: Mt,
  toolbarButtonIcon: Bt
}, Vt = 300, xe = [
  {
    name: "bold",
    icon: /* @__PURE__ */ t("svg", { viewBox: "0 0 20 20", children: /* @__PURE__ */ t("path", { d: "M10.187 17H5.773c-.637 0-1.092-.138-1.364-.415-.273-.277-.409-.718-.409-1.323V4.738c0-.617.14-1.062.419-1.332.279-.27.73-.406 1.354-.406h4.68c.69 0 1.288.041 1.793.124.506.083.96.242 1.36.478.341.197.644.447.906.75a3.262 3.262 0 0 1 .808 2.162c0 1.401-.722 2.426-2.167 3.075C15.05 10.175 16 11.315 16 13.01a3.756 3.756 0 0 1-2.296 3.504 6.1 6.1 0 0 1-1.517.377c-.571.073-1.238.11-2 .11zm-.217-6.217H7v4.087h3.069c1.977 0 2.965-.69 2.965-2.072 0-.707-.256-1.22-.768-1.537-.512-.319-1.277-.478-2.296-.478zM7 5.13v3.619h2.606c.729 0 1.292-.067 1.69-.2a1.6 1.6 0 0 0 .91-.765c.165-.267.247-.566.247-.897 0-.707-.26-1.176-.778-1.409-.519-.232-1.31-.348-2.375-.348H7z" }) }),
    onClick: () => document.execCommand("bold", !1)
  },
  {
    name: "italic",
    icon: /* @__PURE__ */ t("svg", { viewBox: "0 0 20 20", children: /* @__PURE__ */ t("path", { d: "m9.586 14.633.021.004c-.036.335.095.655.393.962.082.083.173.15.274.201h1.474a.6.6 0 1 1 0 1.2H5.304a.6.6 0 0 1 0-1.2h1.15c.474-.07.809-.182 1.005-.334.157-.122.291-.32.404-.597l2.416-9.55a1.053 1.053 0 0 0-.281-.823 1.12 1.12 0 0 0-.442-.296H8.15a.6.6 0 0 1 0-1.2h6.443a.6.6 0 1 1 0 1.2h-1.195c-.376.056-.65.155-.823.296-.215.175-.423.439-.623.79l-2.366 9.347z" }) }),
    onClick: () => document.execCommand("italic", !1)
  },
  {
    name: "underline",
    icon: /* @__PURE__ */ t("svg", { viewBox: "0 0 20 20", children: /* @__PURE__ */ t("path", { d: "M3 18v-1.5h14V18zm2.2-8V3.6c0-.4.4-.6.8-.6.3 0 .7.2.7.6v6.2c0 2 1.3 2.8 3.2 2.8 1.9 0 3.4-.9 3.4-2.9V3.6c0-.3.4-.5.8-.5.3 0 .7.2.7.5V10c0 2.7-2.2 4-4.9 4-2.6 0-4.7-1.2-4.7-4z" }) }),
    onClick: () => document.execCommand("underline", !1)
  },
  {
    name: "insertUnorderedList",
    icon: /* @__PURE__ */ t("svg", { viewBox: "0 0 20 20", children: /* @__PURE__ */ t("path", { d: "M7 5.75c0 .414.336.75.75.75h9.5a.75.75 0 1 0 0-1.5h-9.5a.75.75 0 0 0-.75.75zm-6 0C1 4.784 1.777 4 2.75 4c.966 0 1.75.777 1.75 1.75 0 .966-.777 1.75-1.75 1.75C1.784 7.5 1 6.723 1 5.75zm6 9c0 .414.336.75.75.75h9.5a.75.75 0 1 0 0-1.5h-9.5a.75.75 0 0 0-.75.75zm-6 0c0-.966.777-1.75 1.75-1.75.966 0 1.75.777 1.75 1.75 0 .966-.777 1.75-1.75 1.75-.966 0-1.75-.777-1.75-1.75z" }) }),
    onClick: () => document.execCommand("insertUnorderedList", !1)
  },
  {
    name: "insertOrderedList",
    icon: /* @__PURE__ */ t("svg", { viewBox: "0 0 20 20", children: /* @__PURE__ */ t("path", { d: "M7 5.75c0 .414.336.75.75.75h9.5a.75.75 0 1 0 0-1.5h-9.5a.75.75 0 0 0-.75.75zM3.5 3v5H2V3.7H1v-1h2.5V3zM.343 17.857l2.59-3.257H2.92a.6.6 0 1 0-1.04 0H.302a2 2 0 1 1 3.995 0h-.001c-.048.405-.16.734-.333.988-.175.254-.59.692-1.244 1.312H4.3v1h-4l.043-.043zM7 14.75a.75.75 0 0 1 .75-.75h9.5a.75.75 0 1 1 0 1.5h-9.5a.75.75 0 0 1-.75-.75z" }) }),
    onClick: () => document.execCommand("insertOrderedList", !1)
  }
], Dt = ge(({
  id: u = Le(8),
  name: r,
  onChange: g,
  onFocus: _,
  onBlur: o,
  hidden: O,
  fullWidth: L,
  label: T,
  className: v,
  value: $,
  readOnly: f,
  viewStyle: x = "primary",
  showIconAlways: d,
  containerClass: M,
  labelClass: q,
  error: C,
  errorMessage: B,
  success: A,
  icon: S,
  buttons: N,
  showClearButton: s,
  tooltip: i,
  tooltipClass: z,
  placeholder: I,
  notice: b,
  required: l,
  minLength: a,
  maxLength: R
}, n) => {
  const c = ae(null), [p, h] = K(!1), [m, E] = K(!1), [W, w] = K([]);
  ee(() => {
    document.execCommand("styleWithCSS", !0);
  }, []);
  const y = () => {
    w(xe.filter(({ name: U }) => document.queryCommandState(U)).map(({ name: U }) => U));
  }, V = (U) => {
    g && g({ target: { name: r, value: U } });
  }, e = (U) => {
    _ && _(U), h(!0), E(!0), y();
  }, F = (U) => {
    o && o(U), E(!1), setTimeout(() => h(!1), Vt);
  }, te = () => {
    y();
  }, oe = () => {
    y();
  }, ue = p && s && !!$ && !!Me($, { allowedTags: [] });
  return /* @__PURE__ */ t(
    Ne,
    {
      id: u,
      hidden: O,
      required: l,
      fullWidth: L,
      containerClass: H(M, j.fieldContainer),
      labelClass: H(q, j.label),
      label: T,
      error: C,
      errorMessage: B,
      showClearButton: s,
      notice: b,
      buttons: N,
      icon: S,
      tooltip: i,
      tooltipClass: z,
      isShowClear: ue,
      isShowButtons: p,
      isShowTooltip: m,
      isShowIcon: p || d,
      children: /* @__PURE__ */ P("div", { className: H(j.container, v, p && j.withButtons), children: [
        /* @__PURE__ */ t("div", { className: j.toolbar, children: xe.map(({ name: U, icon: fe, onClick: ne }) => /* @__PURE__ */ t(
          ke,
          {
            viewStyle: "secondary",
            className: H(j.toolbarButton, W.includes(U) && j.active),
            size: "extraSmall",
            iconClassName: j.toolbarButtonIcon,
            icon: fe,
            onClick: () => {
              var re, le;
              (re = c.current) == null || re.focus(), ne(), y(), (le = c.current) == null || le.focus();
            }
          },
          U
        )) }),
        /* @__PURE__ */ t(
          je,
          {
            id: u,
            className: H(
              j.input,
              j[x],
              (S || N || s) && j.withIcon,
              C && "error",
              A && "success",
              f && j.readonly
            ),
            readOnly: f,
            minLength: a,
            maxLength: R,
            placeholder: I,
            onKeyUp: oe,
            onClick: te,
            onChange: V,
            onFocus: e,
            onBlur: F,
            value: $,
            ref: c
          }
        )
      ] })
    }
  );
}), zt = "forma-ui__filling-input__input", At = "forma-ui__filling-input__selectDropdown", Q = {
  input: zt,
  selectDropdown: At
}, Et = {
  Rup: "А-ЯËЁ",
  Eup: "A-Z",
  R: "А-Яа-яËёЁё",
  E: "A-Za-z",
  D: "0-9",
  S: '!@№#;$:?%^&"*.,_—\\-+=()«»„“\\/ '
}, Ft = (u) => u.replace(/[^0-9]/g, "").match(/(357|371|356|386|385|382|372|374)\d{8}|(77|32|36|34|31|48|40|33|46|994|995|996|353|359|420|421)[0-9]{9}|(7|0|44|1|43|30|3|358)\d{10}|(4)\d{11}/), Ot = ({
  data: u,
  form: r,
  search: g,
  onBlur: _,
  onChange: o,
  caseType: O,
  pattern: L,
  icon: T,
  tooltip: v,
  tooltipClass: $,
  options: f,
  ...x
}) => {
  const { t: d, i18n: M } = me(), { currencies: q, lang: C } = _e(he), B = q[C], A = M.resolvedLanguage && M.resolvedLanguage !== "en" ? M.resolvedLanguage.toUpperCase() : "US", { control: S, register: N } = r, {
    type: s,
    id: i,
    inputText: z,
    errorMessage: I = d("errors.validation_required"),
    minLength: b,
    maxLength: l,
    length: a,
    mask: R,
    values: n,
    required: c = !0,
    multiple: p,
    charset: h,
    ownVariant: m
  } = u;
  let { regexp: E } = u;
  if (E || (h && (E = `^[${h.split("").map((w) => Et[w]).join("")}]+$`), s === "decimal" || s === "money" ? E = "^[0-9., ]*$" : (s === "integer" || s === "indexnumber") && (E = "^[0-9 ]*$")), s === "email" && (E = "^.+@.+\\..+$"), s === "date")
    return /* @__PURE__ */ t(
      G,
      {
        control: S,
        name: i,
        defaultValue: "",
        render: ({ field: { onChange: w, onBlur: y, ...V } }) => /* @__PURE__ */ t(
          Pe,
          {
            id: i,
            className: Q.input,
            placeholder: z,
            ...x,
            ...V,
            ...N(i, {
              required: !!(c && I)
            }),
            onBlur: (e) => {
              y(), _ && _(e);
            },
            onChange: (e) => {
              o && o(e), w(e);
            },
            "data-testid": `filling_item_${i}`,
            meta: {
              icon: T,
              success: r.success,
              error: r.error,
              tooltip: v,
              tooltipClass: $,
              showIconAlways: !0
            }
          }
        )
      }
    );
  if (s === "list")
    return /* @__PURE__ */ t(
      G,
      {
        control: S,
        name: i,
        defaultValue: "",
        render: ({ field: { onChange: w, onBlur: y, ...V } }) => /* @__PURE__ */ t(
          yt,
          {
            id: i,
            className: Q.select,
            placeholder: z,
            ...x,
            ...V,
            ...N(i, {
              required: !!(c && I),
              pattern: { value: new RegExp(E ?? ""), message: I },
              minLength: { value: b || a, message: I },
              maxLength: { value: l || a || 250, message: I }
            }),
            onBlur: (e) => {
              y(), _ && _(e);
            },
            onChange: (e, F) => {
              O === "upperFirst" && (e.target.value = Y.toUpperFirst(e.target.value)), o && o(e, F), w(e);
            },
            "data-testid": `filling_item_${i}`,
            options: (n == null ? void 0 : n.map((e) => ({ label: e, value: e }))) ?? f,
            multiple: p,
            meta: {
              icon: T,
              success: r.success,
              error: r.error,
              tooltip: v,
              tooltipClass: $,
              showIconAlways: !0,
              showArrow: !1,
              dropdownClassName: H(Q.selectDropdown, `dropdown_${i}`),
              creatable: m,
              ...g
            }
          }
        )
      }
    );
  if (s === "phone")
    return /* @__PURE__ */ t(
      G,
      {
        control: S,
        name: i,
        defaultValue: "",
        render: ({ field: { onChange: w, onBlur: y, ...V } }) => /* @__PURE__ */ t(
          Ze,
          {
            id: i,
            className: Q.input,
            placeholder: z,
            ...x,
            ...V,
            ...N(i, {
              required: !!(c && I),
              // pattern: regexp ? { value: new RegExp(regexp), message: errorMessage } : null,
              validate: (e) => c && !Ft(e) ? I : !0
            }),
            onBlur: (e) => {
              y(), _ && _(e);
            },
            onChange: (e) => {
              o && o(e), w(e);
            },
            defaultMaskCode: A,
            masks: lt,
            "data-testid": `filling_item_${i}`,
            icon: T,
            success: r.success,
            error: r.error,
            tooltip: v,
            tooltipClass: $,
            showIconAlways: !0
          }
        )
      }
    );
  if (s === "checkbox")
    return /* @__PURE__ */ t(
      G,
      {
        control: S,
        name: i,
        defaultValue: "",
        render: ({ field: { value: w, onChange: y, onBlur: V, ...e } }) => /* @__PURE__ */ t(
          We,
          {
            id: i,
            className: Q.ckeckbox,
            placeholder: z,
            checked: w,
            ...x,
            ...e,
            ...N(i, {
              required: !!(c && I)
            }),
            onBlur: (F) => {
              V(), _ && _(F);
            },
            onChange: (F) => {
              o && o(F), y(F);
            },
            "data-testid": `filling_item_${i}`,
            icon: T,
            success: r.success,
            error: r.error,
            tooltip: v,
            tooltipClass: $,
            showIconAlways: !0
          }
        )
      }
    );
  if (s === "textarea")
    return /* @__PURE__ */ t(
      G,
      {
        control: S,
        name: i,
        defaultValue: "",
        render: ({ field: { onChange: w, onBlur: y, ...V } }) => /* @__PURE__ */ t(
          Qe,
          {
            id: i,
            className: Q.textarea,
            placeholder: z,
            minLength: b || a,
            maxLength: l || a || 255,
            ...x,
            ...V,
            ...N(i, {
              required: !!(c && I),
              minLength: { value: b || a, message: I },
              maxLength: { value: l || a || 255, message: I }
            }),
            onBlur: (e) => {
              y(), _ && _(e);
            },
            onChange: (e) => {
              o && o(e), w(e);
            },
            "data-testid": `filling_item_${i}`,
            meta: {
              icon: T,
              success: r.success,
              error: r.error,
              tooltip: v,
              tooltipClass: $,
              showIconAlways: !0
            }
          }
        )
      }
    );
  if (s === "html")
    return /* @__PURE__ */ t(
      G,
      {
        control: S,
        name: i,
        defaultValue: "",
        render: ({ field: { onChange: w, onBlur: y, ...V } }) => /* @__PURE__ */ t(
          Dt,
          {
            id: i,
            className: Q.wysiwyg,
            placeholder: z,
            minLength: b || a,
            maxLength: l || a || 1e3,
            ...x,
            ...V,
            ...N(i, {
              required: !!(c && I),
              minLength: { value: b || a, message: I },
              // maxLength: { value: maxLength || length || 1000, message: errorMessage },
              validate: (e) => Me(e, { allowedTags: [] }).length < (l || a || 1e3) || I
            }),
            onBlur: (e) => {
              y(), _ && _(e);
            },
            onChange: (e) => {
              o && o(e), w(e);
            },
            "data-testid": `filling_item_${i}`,
            icon: T,
            success: r.success,
            error: r.error,
            tooltip: v,
            tooltipClass: $,
            showIconAlways: !0
          }
        )
      }
    );
  let W;
  return ["integer", "indexnumber"].includes(s) || h === "D" ? W = "numeric" : ["decimal", "money"].includes(s) ? W = "decimal" : s === "email" && (W = "email"), /* @__PURE__ */ t(
    G,
    {
      control: S,
      name: i,
      defaultValue: "",
      render: ({ field: { onChange: w, onBlur: y, ...V } }) => /* @__PURE__ */ t(
        Xe,
        {
          id: i,
          className: Q.input,
          placeholder: z,
          pattern: L,
          minLength: b || a,
          maxLength: l || a || 250,
          inputMode: W,
          ...x,
          ...V,
          ...N(i, {
            required: !!(c && I),
            pattern: { value: new RegExp(E ?? ""), message: I },
            minLength: { value: b || a, message: I },
            maxLength: { value: l || a || 250, message: I }
          }),
          onBlur: (e) => {
            s === "money" ? (e.target.value = Y.toPrice(e.target.value, B.code, !0), o && o(e), w(e)) : s === "decimal" && (e.target.value = Y.toDecimal(e.target.value, B.code, !0), o && o(e), w(e)), y(), _ && _(e);
          },
          onChange: (e) => {
            if (O === "upperFirst")
              e.target.value = Y.toUpperFirst(e.target.value);
            else if (["integer", "decimal", "money"].includes(s)) {
              const F = st(e.target), te = e.target.value;
              s === "integer" ? e.target.value = Y.toInt(e.target.value, B.code) : s === "decimal" ? e.target.value = Y.toDecimal(e.target.value, B.code) : s === "money" && (e.target.value = Y.toPrice(e.target.value, B.code));
              const oe = e.target.value;
              F.end += oe.length - te.length, F.start = F.end, at(e.target, F.start, F.end);
            }
            o && o(e), w(e);
          },
          "data-testid": `filling_item_${i}`,
          meta: {
            icon: T,
            success: r.success,
            error: r.error,
            tooltip: v,
            tooltipClass: $,
            mask: R == null ? void 0 : R.replaceAll("X", "*"),
            showIconAlways: !0
          }
        }
      )
    }
  );
}, qt = "forma-ui__filling-item__item", Rt = "forma-ui__filling-item__filled", Ut = "forma-ui__filling-item__icon", Ht = "forma-ui__filling-item__error", Wt = "forma-ui__filling-item__superfield", jt = "forma-ui__filling-item__label", Pt = "forma-ui__filling-item__labelText", Jt = "forma-ui__filling-item__required", Kt = "forma-ui__filling-item__labelButtons", Xt = "forma-ui__filling-item__info", Zt = "forma-ui__filling-item__tooltip", Qt = "forma-ui__filling-item__remove", Gt = "forma-ui__filling-item__removeIcon", Yt = "forma-ui__filling-item__inputSizer", en = "forma-ui__filling-item__hidden", tn = "forma-ui__filling-item__notice", D = {
  item: qt,
  filled: Rt,
  icon: Ut,
  error: Ht,
  superfield: Wt,
  label: jt,
  labelText: Pt,
  required: Jt,
  labelButtons: Kt,
  info: Xt,
  tooltip: Zt,
  remove: Qt,
  removeIcon: Gt,
  inputSizer: Yt,
  hidden: en,
  notice: tn
}, Ce = 24, Ie = ({
  data: u,
  form: r,
  isSuperField: g,
  isFilledDynamicly: _,
  value: o,
  onRemove: O,
  onSelect: L,
  selected: T,
  showSelect: v,
  ...$
}) => {
  const { t: f } = me(), x = ae(null), { id: d, name: M, inputTooltip: q, inputWidth: C = 216, description: B, hidden: A, multiple: S } = u, [N, s] = K(C);
  ee(() => {
    x != null && x.current && C < x.current.scrollWidth + Ce ? s(x.current.scrollWidth + Ce) : s(C);
  }, [o, x]);
  let i = "";
  return Array.isArray(o) ? i = o[0] + "---" : o && (S ? i = o.split(",")[0] : i = o.replace(/\r\n|\r|\n/g, "<br />")), /* @__PURE__ */ P(
    "div",
    {
      id: `filling_item_${d}`,
      className: H(
        D.item,
        r.error && D.error,
        (g || _) && D.superfield,
        A && D.hidden,
        o && !r.error && D.filled
      ),
      style: { width: N + "px" },
      "data-testid": `filling_item_${d}`,
      children: [
        /* @__PURE__ */ P("div", { className: D.label, children: [
          /* @__PURE__ */ t("span", { className: H(D.labelText, u.required !== !1 && D.required), children: M }),
          /* @__PURE__ */ P("span", { className: D.labelButtons, children: [
            B && /* @__PURE__ */ t(
              Ge,
              {
                position: ["bottom left", "bottom right", "bottom center"],
                className: D.tooltip,
                control: /* @__PURE__ */ t("span", { className: D.info, children: /* @__PURE__ */ t(Re, {}) }),
                offsetX: 0,
                children: B
              }
            ),
            v && L && /* @__PURE__ */ t(
              Te,
              {
                containerClass: D.switcher,
                name: `filling_item_checkbox_${d}`,
                size: "small",
                onChange: (z) => L(d, z.target.checked),
                checked: !!T
              }
            ),
            O && u.required === !1 && /* @__PURE__ */ t(
              He,
              {
                size: "small",
                control: /* @__PURE__ */ t(
                  ke,
                  {
                    className: D.remove,
                    viewStyle: "text",
                    iconClassName: D.removeIcon,
                    icon: /* @__PURE__ */ t(qe, {}),
                    title: f("uikit:delete")
                  }
                ),
                title: /* @__PURE__ */ P("span", { children: [
                  f("uikit:do_yo_want_delete"),
                  " “",
                  M,
                  "”?"
                ] }),
                buttons: [
                  {
                    children: f("uikit:delete"),
                    viewStyle: "danger",
                    onClick: () => O(d)
                  },
                  {
                    children: f("uikit:cancel"),
                    viewStyle: "tertiary"
                  }
                ]
              }
            )
          ] })
        ] }),
        v && T && /* @__PURE__ */ t("div", { className: D.notice, children: f("uikit:sending_to_filling") }),
        /* @__PURE__ */ t("div", { className: H(v && T && D.hidden), children: /* @__PURE__ */ t(
          Ot,
          {
            ...$,
            data: u,
            form: r,
            value: o,
            tooltip: r.error ?? q,
            icon: r.error ? /* @__PURE__ */ t(Ue, { className: D.icon, width: 24, height: 24 }) : o && /* @__PURE__ */ t(Oe, { className: D.icon, width: 24, height: 24 })
          }
        ) }),
        /* @__PURE__ */ t(
          "div",
          {
            className: D.inputSizer,
            dangerouslySetInnerHTML: { __html: i },
            ref: x
          }
        )
      ]
    }
  );
}, Gn = () => /* @__PURE__ */ t("div", { className: H(D.item, "skeleton-loader") }), nn = "forma-ui__fill-folder__countLabel", on = "forma-ui__fill-folder__items", rn = "forma-ui__fill-folder__switcher", de = {
  countLabel: nn,
  items: on,
  switcher: rn
}, sn = ({
  id: u,
  name: r,
  tattrs: g,
  register: _,
  errors: o,
  control: O,
  values: L,
  setValue: T,
  showGroupName: v,
  showCount: $,
  showSelect: f,
  onRemove: x,
  selected: d,
  onChangeSelected: M,
  itemsClassName: q
}) => {
  var a, R;
  const { t: C } = me(), { viewport: B, lang: A } = _e(he), S = g && L ? g.filter(({ id: n }) => !!L[n] && !o[n] || f && (d == null ? void 0 : d.includes(n))).length : 0, [N, s] = K({}), i = (n) => {
    Object.keys(n).forEach((c) => {
      const p = !!n[c], h = g.findIndex(({ id: m }) => c === m) !== -1;
      p && h && T(c, n[c], { shouldValidate: !0 });
    }), s((c) => ({ ...c, ...n }));
  }, z = (n, c, p) => {
    if (p) {
      if (n === "companyname") {
        const h = ut(p);
        setTimeout(() => i(h), 0);
      } else if (n === "bankname") {
        const h = ft(p);
        i(h);
      } else if (n === "passport" || n === "passportcode") {
        const h = pt(p);
        i(h);
      } else if (n === "address") {
        const h = Z.address.filter((m) => p && !(L && L[m])).reduce((m, E) => ({ ...m, [E]: c }), {});
        i(h);
      }
    }
  }, I = (n) => {
    s((c) => {
      if (!c[n.target.id])
        return c;
      const p = { ...c };
      return delete p[n.target.id], p;
    });
  }, b = (n, c) => {
    if (!M)
      return;
    const p = d ? [...d] : [];
    n.forEach((h) => {
      if (c)
        p.includes(h) || p.push(h);
      else {
        const m = p.indexOf(h);
        if (m === -1)
          return;
        p.splice(m, 1);
      }
    }), M(p);
  }, l = dt === u && g.findIndex(({ id: n }) => Z.company.includes(n)) === -1 && (g.findIndex(({ id: n }) => Z.inn.includes(n)) >= 0 || g.findIndex(({ id: n }) => Z.ogrnip.includes(n)) >= 0) && ve("companyname");
  return /* @__PURE__ */ t(
    ct,
    {
      id: u && `fill_group_content_${u}`,
      title: v && r,
      buttons: !!(f && M || v && $) && /* @__PURE__ */ P(Ee, { children: [
        f && M && /* @__PURE__ */ t(
          Te,
          {
            containerClass: de.switcher,
            name: `checkbox_${u}`,
            label: B !== "phone" && C("uikit:select_block"),
            size: "small",
            onChange: (n) => b(g.map(({ id: c }) => c), n.target.checked),
            checked: g.every(({ id: n }) => d == null ? void 0 : d.includes(n))
          }
        ),
        v && $ && (f ? /* @__PURE__ */ P("span", { children: [
          /* @__PURE__ */ P("span", { className: de.countLabel, children: [
            C("uikit:filled_or_selected"),
            ":"
          ] }),
          " ",
          S,
          "/",
          g.length
        ] }) : /* @__PURE__ */ P("span", { children: [
          /* @__PURE__ */ P("span", { className: de.countLabel, children: [
            C("uikit:filled"),
            ":"
          ] }),
          " ",
          S,
          "/",
          g.length
        ] }))
      ] }),
      percent: $ && 100 * S / g.length,
      children: /* @__PURE__ */ P("div", { className: H(de.items, q), children: [
        l && /* @__PURE__ */ t(
          Ie,
          {
            data: {
              id: `${u}_${Z.company[0]}`,
              name: C("uikit:full_company_name"),
              lang: A,
              type: l.type,
              values: l.values,
              inputText: C("uikit:full_company_name_placeholder"),
              inputWidth: 1200
            },
            form: {
              register: _,
              control: O,
              error: (a = o[`${u}_${Z.company[0]}`]) == null ? void 0 : a.message,
              success: !!(L != null && L[`${u}_${Z.company[0]}`] && !((R = o[`${u}_${Z.company[0]}`]) != null && R.message))
            },
            onChange: (n, c) => {
              if (!c)
                return;
              const p = n.target;
              z("companyname", p.value, c);
            },
            search: {
              loadingUrl: l == null ? void 0 : l.loadingUrl,
              loadingMethod: l == null ? void 0 : l.loadingMethod,
              loadingMapper: l == null ? void 0 : l.loadingMapper
            },
            showSelect: f,
            isSuperField: !0
          }
        ),
        g && g.map((n, c) => {
          var E, W;
          const p = L && L[n.id] ? L[n.id] : "", h = mt(n.id, n.type), m = h ? ve(h) : null;
          return /* @__PURE__ */ t(
            Ie,
            {
              data: {
                ...n,
                type: (m == null ? void 0 : m.type) || n.type,
                values: (m == null ? void 0 : m.values) || n.values
              },
              form: {
                control: O,
                register: _,
                error: (E = o[n.id]) == null ? void 0 : E.message,
                success: !!(p && !((W = o[n.id]) != null && W.message))
              },
              search: {
                loadingUrl: m == null ? void 0 : m.loadingUrl,
                loadingMethod: m == null ? void 0 : m.loadingMethod,
                loadingMapper: m == null ? void 0 : m.loadingMapper
              },
              isSuperField: !!m,
              isFilledDynamicly: !!N[n.id],
              value: p,
              onChange: (w, y) => {
                if (!y)
                  return;
                const V = w.target;
                N && I(w), h && z(h, V.value, y);
              },
              onRemove: x,
              showSelect: f,
              selected: d == null ? void 0 : d.includes(n.id),
              onSelect: (w, y) => b([w], y)
            },
            n.id + c
          );
        })
      ] })
    }
  );
}, an = "forma-ui__fill-form__groups", ln = "forma-ui__fill-form__counteragents", $e = {
  groups: an,
  counteragents: ln
}, Yn = ge(({
  values: u,
  folders: r,
  selected: g,
  onChange: _,
  onErrors: o,
  onChangeSelected: O,
  onChangeValid: L,
  showCount: T,
  showGroupName: v,
  showSelect: $
}, f) => {
  const { register: x, watch: d, control: M, reset: q, getValues: C, setValue: B, trigger: A, formState: { errors: S, isValid: N } } = Fe({
    mode: "onChange",
    defaultValues: u
  });
  f && (f.current = { reset: q, getValues: C, setValue: B, revalidate: A });
  const s = ye(() => r == null ? void 0 : r.flatMap(({ tattrs: b }) => b), [r]);
  ee(() => {
    if (s) {
      const b = C(), l = {};
      Object.keys(b).forEach((a) => {
        b[a] && !s.find(({ id: R }) => R === a) ? l[a] = "" : l[a] = b[a];
      }), q(l);
    }
    setTimeout(() => A());
  }, [JSON.stringify(s)]);
  const i = ye(() => N, [N]);
  ee(() => {
    L(N);
  }, [i]);
  const z = Object.keys(S).reduce((b, l) => {
    var a;
    return { ...b, [l]: ((a = S[l]) == null ? void 0 : a.message) ?? "" };
  }, {});
  ee(() => {
    o(z);
  }, [JSON.stringify(z)]);
  const I = Se(_, 50);
  return ee(() => {
    const b = d((l) => {
      const a = Object.keys(l).reduce((R, n) => ({ ...R, [n]: l[n] || void 0 }), {});
      I(a);
    });
    return () => b.unsubscribe();
  }, [d]), /* @__PURE__ */ t("div", { className: $e.root, children: /* @__PURE__ */ t("div", { className: $e.groups, children: r == null ? void 0 : r.map(({ id: b, name: l, tattrs: a }) => a != null && a.length ? /* @__PURE__ */ t(
    sn,
    {
      id: b,
      name: l,
      tattrs: a,
      register: x,
      errors: S,
      control: M,
      setValue: B,
      values: u,
      showGroupName: v,
      showCount: T,
      showSelect: $,
      onChangeSelected: O,
      selected: g
    },
    b
  ) : null) }) });
});
export {
  Yn as F,
  yt as S,
  Dt as W,
  sn as a,
  Ie as b,
  Gn as c,
  Ot as d,
  _t as u
};
